"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionGroup = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _AccordionGroupModule = _interopRequireDefault(require("./AccordionGroup.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const AccordionGroup = _ref => {
  let {
    children,
    onAccordionClick,
    onToggle,
    initialOpenId = '',
    classNames,
    testId
  } = _ref;
  const [openId, setOpenedId] = React.useState(initialOpenId);
  const handleAccordionChange = (id, isOpen) => {
    setOpenedId(isOpen ? id : '');
    onAccordionClick?.(id, isOpen);
  };
  const handleToggle = (id, checked) => {
    setOpenedId(prev => checked ? id : prev === id ? '' : prev);
    onToggle?.(id, checked);
  };
  const enhancedChildren = React.Children.map(children, child => {
    if (! /*#__PURE__*/React.isValidElement(child)) {
      return null;
    }
    const childId = child.props.id;
    const isOpen = openId === childId;
    const accordionOnToggle = checked => {
      handleToggle(childId, checked); // parents onToggle, pass id as well.
      child.props.onToggle?.(checked);
    };
    return /*#__PURE__*/React.cloneElement(child, {
      classNames: {
        ...child.props.classNames,
        wrapper: (0, _classify.default)(_AccordionGroupModule.default.accordionWrapper, child.props.classNames?.wrapper)
      },
      onChange: handleAccordionChange,
      onToggle: accordionOnToggle,
      showToggle: true,
      isOpen,
      key: childId,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'accordion',
        index: childId
      })
    });
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classify.default)(_AccordionGroupModule.default.wrapper, classNames?.wrapper),
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'wrapper'
    }),
    children: enhancedChildren
  });
};
exports.AccordionGroup = AccordionGroup;
AccordionGroup.displayName = 'AccordionGroup';